import { navigate } from '@reach/router';

import { IEventRound } from '../../../../../store/admin/eventRounds/store';
import { IAdminEvent } from '../../../../../store/admin/events/store';

export const onForward = (
  clubId: string,
  event: IAdminEvent,
  roundId: string,
  round?: IEventRound
) => () =>
  navigate(
    `/staff/club/${clubId}/event/${event.id}/round/${roundId}/${
      round && round.order === 0 && event.flights.length > 1 ? 'flights' : 'launch'
    }`
  );
